import React from 'react';
import '../styles/About.css';
import useSafeBack from '../hooks/useSafeBack';

function About() {
  const safeBack = useSafeBack('/');

  return (
    <div className="about-page">
      <div className="about-page__bg" aria-hidden />
      <div className="sa-page about-page__inner">
        <div className="sa-container about-page__narrow">
          <button
            type="button"
            className="about-page__back"
            onClick={safeBack}
            aria-label="Go back"
          >
            ← Back
          </button>

          <header className="about-hero">
            <p className="about-hero__eyebrow">Our story</p>
            <h1 className="about-hero__title">About SkillArea</h1>
            <p className="about-hero__lead">
              We connect people who need skilled help with technicians who can deliver it — clearly,
              quickly, and fairly.
            </p>
          </header>

          <section className="about-block" aria-labelledby="about-mission">
            <h2 id="about-mission" className="about-block__title">
              Mission
            </h2>
            <p className="about-block__text">
              SkillArea exists to make hiring trustworthy technicians easy: whether you’re fixing a
              home, a business, or learning a trade, you should know who you’re working with and what
              to expect.
            </p>
          </section>

          <section className="about-pillars" aria-label="What we focus on">
            <article className="about-pillar">
              <div className="about-pillar__bar" aria-hidden />
              <h3 className="about-pillar__title">For clients</h3>
              <p className="about-pillar__text">
                Find technicians by skill and area, compare options, and book with confidence.
              </p>
            </article>
            <article className="about-pillar">
              <div className="about-pillar__bar" aria-hidden />
              <h3 className="about-pillar__title">For technicians</h3>
              <p className="about-pillar__text">
                Showcase your expertise, reach people who need your work, and grow your reputation.
              </p>
            </article>
            <article className="about-pillar">
              <div className="about-pillar__bar" aria-hidden />
              <h3 className="about-pillar__title">For everyone</h3>
              <p className="about-pillar__text">
                A platform built on clarity, respect for trades, and tools that work in real life.
              </p>
            </article>
          </section>

          <p className="about-footnote">
            SkillArea is under active development — features and availability may change as we grow.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
